// dev
// export const API_ENDPOINT = "https://6serfqmftyfx4c6ngcxz2ozmlm0rxoqy.lambda-url.ap-southeast-2.on.aws/"

// production
export const API_ENDPOINT = "https://tkbu4in36sdk76darjap2zrvnq0dorva.lambda-url.us-east-1.on.aws/"
export const DEFAULT_CATEGORIES = ["Arts", "Business", "Food", "Shopping", "Sports"]
export const STORAGE = "localStorage"